import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/common_action/fillList_action";
import {
    voucherActionId,
    bankAccountActionId,
    paymentModeActionId,
    receiptAccountTypeActionId,
    toastError,
    downloadReport,
    toastSuccess,
    applicantActionId,
    BASE_URL,
    allApplicantActionId,
    responseError
} from "../../../utils/constants";
import DatePicker from 'react-datepicker';
import {
    proformaInvoice_action, receiptNo_action, generateVoucher_action, receipt_entry_save_action,
    receiptDetails_action, receiptUpdate_action, receipt_outstanding_mail_action
} from "../../../actions/accounts_action/receipt_action/receipt_action";
// import Modal from "react-modal"
// import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast, } from "react-toastify";
import moment from "moment";
import Header from "../../../common_components/Header";
import $ from 'jquery'
// import { download_no_due_action, download_tax_invoice_action, download_exitPass_action, update_exit_pass_action } from '../../../actions/myOrders_action/myOrders_action';
import { Button, Modal } from "react-bootstrap";
import MobileHeader from "../../../common_components/mobileHeader";
import Footer from "../../../common_components/Footer";
class ReceiptManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false, isCollapse: false,
            isAccordionExpanded: false,
            receiptPreviewModal: false, receiptFilePath: "", taxInvoiceFilePath: "",
            voucherId: "",
            voucherList: "",
            bankAccountId: "",
            bankAccountList: "",
            paymentModeId: "",
            paymentModeList: "",
            AccountTypeID: "",
            Amount: '',
            receiptAccountTypeList: [],
            applicant_id: "",
            applicantNameList: [],
            tempApplicantList: [],
            billTempapplicantList: [],
            isDisplayapplicantList: false,
            newClienId: '',
            show: false,
            performaInvoiceRecieptList: [],
            chekedPerformaList: [],
            otherChargesList: [
                {
                    AccountTypeID: "",
                    Amount: "",
                    deleteRowId: 1,
                },
            ],
            token: "",
            currency: "",
            conversionRate: 1,
            bankAmount: "",
            tdsAmount: "",
            exchdiif: "",
            onAccAmt: "",
            crAmount: 0,
            totalAmount: "",
            receiptNo: "",
            receiptDate: "",
            paymentReceivedDate: "",
            instrumentNo: "",
            instrumentDate: "",
            bankName: "",
            branchName: "",
            narration: "",
            Is_add: false,
            Is_update: false,
            applicantId: '',
            ReceiptId: '',
            UserId: '',
            addTaxableAmmount: '',
            addTotalPayableAmmount: '',
            addPendingAmmount: '',
            addReceivedAmmount: '',
            isGenVoucherDisabled: false,
            checkAll: false,
            ledgerList: [],
            subLedgerList: [],

            // Input Errors
            voucherTypeErr: "",
            applicantErr: "",
            bankAccountErr: "",
            bankAmountErr: "",
            tdsAmountErr: "",
            pymtModeErr: "",
            otherChargesListErr: "",
            totalsErr: "",
            from: '',
            ReceivedAmount: '',
            newPerformaInvoiceRecieptList: [],
            isEditGenerateVoucher: false,
            onPreview: false,
            account: false,
            ammount: false,
            isDisableProformaInvoice: false,
            totalAmountErr: '',
            dummyArray: [],
            paymentReceivedDate: new Date,
            receiptDate: new Date,
            OrderID: '',
            buttomButtonList: {},
            rptDetailsObj: {},
            LedgerCreditAmountErr: '',
            adminReceipt: false,
            OrderNo: '',
            paidAmount: '',
            piSendShow: false,
            ProformaInvoiceID: '',
            ProformaInvoice_No: '',
            isTaxInvoiceFlag: false,
            createdBy: "",
            createdDate: "",
            deletedBy: "",
            deletedDate: "",
            modifiedBy: "",
            modifiedDate: "", outstanding: '',
            award_event_profile_id: '',
            systemInfo: [
                {
                    Created_by_user: null,
                    Created_date: null,
                    modified_by_user: null,
                    modified_date: null,
                    deleted_by_user: null,
                    modified_date: null,
                    deleted_by_user: null,
                    deleted_date: null,
                }
            ],
            applicant_name: '',
        };
    }

    componentDidMount = () => {
        this.getFillList(voucherActionId, "");
        this.getFillList(bankAccountActionId, "");
        this.getFillList(paymentModeActionId, "");
        this.getFillList(receiptAccountTypeActionId, "");
        if (this.props.location.state.Is_update) {
            this.getFillList(allApplicantActionId, "", sessionStorage.getItem("award_event_id"));
        } else {
            this.getFillList(applicantActionId, "", sessionStorage.getItem("award_event_id"));
        }

        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }
        this.loadscript()

        this.setState({
            Is_update: this.props.location.state != null && this.props.location.state.Is_update ? this.props.location.state.Is_update : false
        })

        setTimeout(() => {
            this.props.location.state != null && this.props.location.state.Is_update && this.getAccounteReceiptDetails()
        }, 200);
    };

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    // Generate Report
    generateNoDue() {
        const { rptDetailsObj } = this.state
        this.setState({ isLoading: true });
        this.props
            .generate_nodue_action(
                rptDetailsObj.OrderID,
                rptDetailsObj.OrderNo,
                rptDetailsObj.CompanyName,
                rptDetailsObj.UserEmail,
                rptDetailsObj.ProformaInvoiceID,
                rptDetailsObj.ProformaInvoice_No
            )
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    toast.success("No Due Generated Successfully", {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                    this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    generateTaxInvoice() {
        const { rptDetailsObj } = this.state
        this.setState({ isLoading: true });
        this.props
            .generate_taxInvoice_action(
                rptDetailsObj.OrderID,
                rptDetailsObj.OrderNo,
                rptDetailsObj.CompanyName,
                rptDetailsObj.UserEmail,
                rptDetailsObj.ProformaInvoiceID,
                rptDetailsObj.ProformaInvoice_No
            )
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    const url = BASE_URL.split("/api")[0];
                    const structurePath = data.data.filePath.replace('./', '/');
                    const FilePath = `${url}${structurePath}`;
                    this.setState({
                        isTaxInvoiceFlag: true,
                        piSendShow: true, ProformaInvoiceID: rptDetailsObj.ProformaInvoiceID, ProformaInvoice_No: rptDetailsObj.ProformaInvoice_No,
                        OrderID: rptDetailsObj.OrderID, taxInvoiceFilePath: FilePath, OrderNo: rptDetailsObj.OrderNo
                    }, () => {

                        this.openTaxInvoiceModal(
                            rptDetailsObj.ProformaInvoiceID,
                            rptDetailsObj.ProformaInvoice_No,
                            rptDetailsObj.OrderID,
                            FilePath,
                            rptDetailsObj.OrderNo
                        );
                    })
                    // toast.success("Tax Invoice Generated Successfully", {
                    //   position: "top-center",
                    //   theme: "colored",
                    //   autoClose: 3000,
                    //   hideProgressBar: true,
                    // });
                    // this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    sendTaxInvoice() {
        const { ProformaInvoiceID, ProformaInvoice_No, rptDetailsObj } = this.state;
        this.setState({ isLoading: true })
        this.props
            .send_tax_invoice_action(rptDetailsObj.OrderID, rptDetailsObj.OrderNo, rptDetailsObj.CompanyName, rptDetailsObj.UserEmail, ProformaInvoiceID, ProformaInvoice_No)
            .then((data) => {
                if (data.error !== 1) {
                    toastSuccess("Tax Invoice Send Successfully!")
                    this.setState({ piSendShow: false, isLoading: false })
                } else {
                    responseError(data)
                }
            })
            .catch((err) => {
                console.error(err); // Logging the error for debugging
                this.setState({ isLoading: false, exitSub: false });
            });
    }

    openTaxInvoiceModal(ProformaInvoiceID, ProformaInvoice_No, OrderID, filePath, OrderNo) {
        this.setState({
            piSendShow: true, ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No, OrderID: OrderID, taxInvoiceFilePath: filePath, OrderNo: OrderNo
        })
    }

    updateExitPass() {
        this.setState({ isLoading: true });
        const { rptDetailsObj } = this.state
        this.props
            .update_exit_pass_action(
                rptDetailsObj.OrderID,
                rptDetailsObj.OrderNo,
                rptDetailsObj.CompanyName,
                rptDetailsObj.UserEmail,
                rptDetailsObj.UUID
            )
            .then((data) => {

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    toast.success("Exit pass generated Successfully", {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                    this.getAccounteReceiptDetails(); // Fetch the updated list of holidays
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // Download Report
    downloadNoDue() {
        const { rptDetailsObj } = this.state;
        this.setState({ isLoading: true });
        if (rptDetailsObj.OrderID) {
            const formattedOrderNo = rptDetailsObj.OrderNo.replace(/[\/-]/g, "_");
            this.props
                .download_no_due_action(rptDetailsObj.OrderID, formattedOrderNo)
                .then((downloadData) => {
                    if (downloadData.error !== 1) {
                        this.setState({ isLoading: false });
                        const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
                        window.open(url, "_blank");
                    } else {
                        responseError(downloadData)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
            toast.error("Cannot download: OrderID not found.", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
        }
    }
    downloadTaxInvoice() {
        const { rptDetailsObj } = this.state;
        this.setState({ isLoading: true });
        const userId = sessionStorage.getItem("userId")
        if (rptDetailsObj.ProformaInvoiceID) {
            const formattedOrderNo = rptDetailsObj.ProformaInvoice_No.replace(/[\/-]/g, "_");
            this.props
                .download_tax_invoice_action(userId, rptDetailsObj.ProformaInvoiceID, formattedOrderNo)
                .then((downloadData) => {
                    if (downloadData.error !== 1) {
                        this.setState({ isLoading: false });
                        const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
                        window.open(url, "_blank");
                    } else {
                        responseError(downloadData)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
            toast.error("Cannot download: OrderID not found.", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
        }
    }
    downloadExitPass() {
        const { rptDetailsObj } = this.state;
        this.setState({ isLoading: true });
        const userId = sessionStorage.getItem("userId")
        if (rptDetailsObj.OrderID) {
            const formattedOrderNo = rptDetailsObj.ProformaInvoice_No.replace(/[\/-]/g, "_");
            this.props
                .download_exitPass_action(userId, rptDetailsObj.OrderID, formattedOrderNo)
                .then((downloadData) => {
                    if (downloadData.error !== 1) {
                        this.setState({ isLoading: false });
                        const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
                        window.open(url, "_blank");
                    } else {
                        responseError(downloadData)
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
            toast.error("Cannot download: OrderID not found.", {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
            });
        }
    }

    // Input Feilds Validation
    inputValidate() {
        const { voucherId, newClienId, applicant_id, bankAccountId, bankAmount, tdsAmount, paymentModeId, isGenVoucherDisabled } = this.state
        // if (newClienId != "" && applicant_id != "" && bankAccountId != "" && bankAmount != "") {
        if (voucherId == "" || voucherId == "Select") {
            this.setState({ voucherTypeErr: 'Please select voucher type' })
        }
        // }
        if (applicant_id == "Select" || applicant_id == "") {
            this.setState({ applicantErr: 'Please select applicant' })
        }
        if (bankAccountId == "" || bankAccountId == "Select") {
            this.setState({ bankAccountErr: 'Please select bank account' })
        }
        if (bankAmount == "") {
            this.setState({ bankAmountErr: 'Please enter bank amount' })
        }
        if (tdsAmount != null && tdsAmount == "") {
            this.setState({ tdsAmountErr: 'Please enter TDS amount' })
        }
        if (isGenVoucherDisabled) {
            if (paymentModeId == "" || paymentModeId == "Select") {
                this.setState({ pymtModeErr: 'Please select payment Mode' })
            }
        }
    }

    getPerformaInvoiceRecieptList() {
        const { applicant_id, newPerformaInvoiceRecieptList } = this.state
        this.setState({ isLoading: true });
        this.props
            .proformaInvoice_action(applicant_id)
            .then((data) => {
                if (data.error != 1) {
                    // this.props.location.state.Is_update == false ?
                    //   : <></>
                    this.setState({ isLoading: false });
                    if (data.data != '') {
                        data.data.sort((a, b) => a.proforma_invoice_id + b.proforma_invoice_id)
                        this.setState({ isLoading: false });
                        if (this.props.location.state.Is_add) {
                            const filterArray = data.data.filter(item => item.outstanding != 0)
                            this.setState({ performaInvoiceRecieptList: filterArray })

                            this.setState({ chekedPerformaList: filterArray }, () => {
                                this.autoFillReceivedAmount()
                            }, () => this.calculateTotals())

                            setTimeout(() => {
                                const { totalCurrPend } = this.calculateTotals()
                                if (totalCurrPend != 0) {
                                    this.handleOnAccAmt()
                                } else {
                                    this.setState({ onAccAmt: 0.00 })
                                }
                            }, 500);
                        } else {
                            var dummyPerformaList = data.data
                            dummyPerformaList.map((data, index) => {
                                newPerformaInvoiceRecieptList.map((item, e) => {
                                    if (data.proforma_invoice_id == item.proforma_invoice_id) {
                                        data.Is_Check = 1
                                        data.ReceivedAmount = item.received_amount
                                        // data.Pending = (data.Pending + item.ReceivedAmount)
                                    }
                                })
                            })
                            this.setState({
                                chekedPerformaList: dummyPerformaList,
                                award_event_profile_id: dummyPerformaList.length > 0 && dummyPerformaList[0]['award_event_profile_id']
                            })
                        }
                    }

                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });

        // sessionStorage.setItem("userName", userName)
    }

    getAccounteReceiptDetails() {
        const ReceiptId = this.props.location.state.receipt_id

        this.setState({ isLoading: true });
        this.props
            .receiptDetails_action(ReceiptId)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data['data'] != '' && data.data['performaInvoice'] != '') {
                    //     this.setState({
                    //         buttomButtonList: {
                    //             isOutstandingZero: data.data['performaInvoice'][0]['isOutstandingZero'],
                    //             isNoDue: data.data['performaInvoice'][0]['isNoDue'],
                    //             FinalExitSubmit: data.data['performaInvoice'][0]['FinalExitSubmit'],
                    //             isExitPass: data.data['performaInvoice'][0]['isExitPass'],
                    //             IsTaxInvoiceGenerated: data.data['performaInvoice'][0]['IsTaxInvoiceGenerated'],
                    //         },
                    //         rptDetailsObj: {
                    //             CompanyName: data.data['data'][0]['CompanyName'],
                    //             UserName: data.data['data'][0]['UserName'],
                    //             UserEmail: data.data['data'][0]['UserEmail'],
                    //             OrderID: data.data['performaInvoice'][0]['OrderID'],
                    //             OrderNo: data.data['performaInvoice'][0]['OrderNo'],
                    //             ProformaInvoiceID: data.data['performaInvoice'][0]['ProformaInvoiceID'],
                    //             ProformaInvoice_No: data.data['performaInvoice'][0]['ProformaInvoice_No'],
                    //             ProformaType: data.data['performaInvoice'][0]['ProformaType'],
                    //             UUID: data.data['performaInvoice'][0]['UUID'],
                    //             receiptFilePath: data.data['data'][0]['receiptFilePath'], taxInvoiceFilePath: data.data['performaInvoice'][0]['taxInvoiceFilePath'],
                    //         },
                    //         isTaxInvoiceFlag: data.data['performaInvoice'][0]['IsTaxInvoiceGenerated']
                    //     })

                    // }
                    this.setState({
                        voucherId: data.data['data'][0]['voucher_type_id'],
                        applicant_id: data.data['data'][0]['application_form_id'],
                        bankAccountId: data.data['data'][0]['bank_detail_id'],
                        currency: data.data['data'][0]['currency_id'],
                        conversionRate: data.data['data'][0]['conversion_rate'],
                        bankAmount: data.data['data'][0]['bank_amount'],
                        tdsAmount: data.data['data'][0]['tds_amount'] != null ? parseFloat(data.data['data'][0]['tds_amount']).toFixed(2) : '',
                        exchdiif: data.data['data'][0]['exchange_difference'] != null ? parseFloat(data.data['data'][0]['exchange_difference']).toFixed(2) : null,
                        onAccAmt: data.data['data'][0]['on_acc_amount'],
                        crAmount: data.data['data'][0]['credit_amount'] != null ? parseFloat(data.data['data'][0]['credit_amount']).toFixed(2) : null,
                        totalAmount: data.data['data'][0]['total_amount'],
                        receiptNo: data.data['data'][0]['receipt_no'],
                        receiptDate: data.data['data'][0]['receipt_date'] != null ? data.data['data'][0]['receipt_date'] : '',
                        paymentModeId: data.data['data'][0]['payment_mode_id'],
                        instrumentNo: data.data['data'][0]['instrument_no'],
                        instrumentDate: data.data['data'][0]['instrument_date'] != null ? moment(data.data['data'][0]['instrument_date'], 'YYYY-MM-DD').toDate() : '',
                        paymentReceivedDate: data.data['data'][0]['payment_received_date'] != null ? moment(data.data['data'][0]['payment_received_date'], 'YYYY-MM-DD').toDate() : '',
                        bankName: data.data['data'][0]['bank_name'],
                        branchName: data.data['data'][0]['branch_name'],
                        narration: data.data['data'][0]['narration'],
                        outstanding: data.data['data'][0]['outstanding'],
                        newPerformaInvoiceRecieptList: data.data['proformaList'],
                        dummyArray: data.data['proformaList'],
                        isLoading: false,
                        systemInfo: [
                            {
                                Created_by_user: data.data['data'][0]['Created_by_user'],
                                Created_date: data.data['data'][0]['Created_date'],
                                modified_by_user: data.data['data'][0]['modified_by_user'],
                                modified_date: data.data['data'][0]['modified_date'],
                                deleted_by_user: data.data['data'][0]['deleted_by_user'],
                                modified_date: data.data['data'][0]['modified_date'],
                                deleted_by_user: data.data['data'][0]['deleted_by_user'],
                                deleted_date: data.data['data'][0]['deleted_date'],
                            }
                        ]
                    }, () => {
                        this.state.applicantNameList.length > 0 && this.state.applicantNameList.map((item) => {
                            if (item.application_form_id == data.data['data'][0]['application_form_id']) {
                                this.setState({ applicant_name: item.name + " (" + item.application_no + ")" })
                            }
                        })
                    });
                    if (data.data['otherCharges'] != '') {
                        const array = []
                        data.data['otherCharges'].map((item, i) => {
                            array.push({
                                AccountTypeID: item.account_type_id,
                                Amount: item.amount,
                                deleteRowId: i + 1
                            })
                        })
                        this.setState({ otherChargesList: array })
                    }
                    this.setState({ isLoading: false });

                    setTimeout(() => {
                        this.getPerformaInvoiceRecieptList()
                    }, 100);

                    setTimeout(() => {
                        this.calculateTotals()
                        this.handleTotalAmt()
                    }, 200);

                    // setTimeout(() => {
                    //   this.handleOnAccAmt()

                    // }, 500);

                    if (data.data['otherCharges'] != '') {
                        data.data['otherCharges'].map((data, i) => {
                            data.deleteRowId = i++
                        })
                    }

                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });



        // sessionStorage.setItem("userName", userName)
    }

    getReceiptNo() {
        const { applicantId } = this.state
        this.props
            .receiptNo_action(sessionStorage.getItem('award_event_id'))
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        this.setState({
                            receiptNo: data.data[0]['receipt_no'],
                            receiptDate: new Date(),
                        });
                    }
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });



        // sessionStorage.setItem("userName", userName)
    }

    modalShow() {
        const { newClienId, bankAccountId, bankAmount, tdsAmount, applicant_id } = this.state

        if (applicant_id != '' && bankAccountId != '' && bankAccountId != 'Select' && bankAmount != '') {
            this.setState({
                show: true,
            });
        } else {
            this.inputValidate()
            toastError("Please fill mendetory feilds")
        }

    };

    modalClose = () => {
        this.setState({ show: false })
    }

    getFillList(value, userID, keyword, keyvalue) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(value, userID == "" || userID == null ? null : userID, keyword, keyvalue)
            .then((data) => {
                if (data.error != 1) {
                    if (value == voucherActionId) {
                        this.setState({ voucherList: data.data, isLoading: false });
                    }
                    if (value == bankAccountActionId) {
                        this.setState({ bankAccountList: data.data, isLoading: false });
                    }
                    if (value == paymentModeActionId) {
                        this.setState({ paymentModeList: data.data, isLoading: false });
                    }
                    if (value == receiptAccountTypeActionId) {
                        this.setState({
                            receiptAccountTypeList: data.data,
                            isLoading: false,
                        });
                    }
                    if (value == allApplicantActionId) {
                        this.setState({
                            applicantNameList: data.data,
                            tempApplicantList: data.data,
                        })
                    }
                    if (value == applicantActionId) {
                        this.setState({
                            applicantNameList: data.data,
                            tempApplicantList: data.data,
                        })
                    }

                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onApplicantSelect(e) {
        const { applicantNameList } = this.state
        const event = e.target.value
        if (event != '' && event != 'Select') {
            const currency = applicantNameList.filter(item => item.application_form_id == event)[0]['currency']
            this.setState({ applicant_id: e.target.value, isDisplayapplicantList: false, applicantErr: '', dummyArray: [], currency: currency })
            setTimeout(() => {
                this.getPerformaInvoiceRecieptList()
                this.getReceiptNo()
                this.setState({ chekedPerformaList: [], checkAll: false })
            }, 100);
        } else {
            this.setState({ applicant_id: '' })
        }
    }

    chekedPerformaList() {
        const { performaInvoiceRecieptList, chekedPerformaList, } = this.state;
        const List = performaInvoiceRecieptList
        // if (performaInvoiceRecieptList != '') {
        //     performaInvoiceRecieptList.map((data) => {
        //         if (data.Is_Check == 1) {
        //             List.push(data)
        //         }
        //     })
        // }
        this.setState({
            chekedPerformaList: List,
            paidAmount: List[0]['PaidAmount']
        })
    }

    tableBodyCheckbox(index, orderId, e) {
        const { performaInvoiceRecieptList, dummyArray, chekedPerformaList } = this.state;
        const pList = [...performaInvoiceRecieptList];
        const event = e.target.checked;
        if (event == true) {
            pList.forEach((data, i) => {
                if (i === index) {
                    dummyArray.push(data)
                    if (dummyArray.length > 0) {
                        if (dummyArray[0]['OrderID'] == data.OrderID) {
                            data.Is_Check = 1
                        } else {
                            data.Is_Check = 0
                            var filter = dummyArray.filter(item => data.ProformaInvoiceID != item.ProformaInvoiceID)
                            this.setState({ dummyArray: filter })
                        }
                    }
                } else {
                    data.Is_Check = 0
                }
            });
        } else {
            pList.forEach((data, i) => {
                if (i === index) {
                    var filter = dummyArray.filter(item => data.ProformaInvoiceID != item.ProformaInvoiceID)
                    this.setState({ dummyArray: filter })
                    data.Is_Check = 0;
                }
            });
        }
        this.setState({
            performaInvoiceRecieptList: pList,
        });

        const AllSelected = pList.every(item => item.Is_Check == 1)
        if (AllSelected) {
            this.setState({ checkAll: true })
        } else {
            this.setState({ checkAll: false })
        }


    }

    tableHeadCheckbox(e) {
        const { performaInvoiceRecieptList } = this.state;
        const pList = [...performaInvoiceRecieptList];
        if (e.target.checked == true) {
            pList.forEach((data, i) => {
                data.Is_Check = 1;
                this.setState({
                    performaInvoiceRecieptList: pList,
                    checkAll: true
                });
            });
        } else {
            pList.forEach((data, i) => {
                data.Is_Check = 0;
                this.setState({
                    performaInvoiceRecieptList: pList,
                    checkAll: false
                });
            });
        }

    }

    //handle Bank Amount
    handleBankAmount(e) {
        this.setState({ bankAmount: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '' })
        this.handleTotalAmt()
        const { totalCurrPend } = this.calculateTotals()
        setTimeout(() => {
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            }
        }, 300);
        setTimeout(() => {
            this.autoFillReceivedAmount()
        }, 500);
    }

    // handle On Acc Amt 
    handleOnAccAmt() {
        const { totalAmount, onAccAmt } = this.state
        const { totalCurrPend } = this.calculateTotals()
        const CalOnAccAmt = parseFloat(totalAmount) - parseFloat(totalCurrPend)
        if (CalOnAccAmt >= 0) {
            this.setState({ onAccAmt: CalOnAccAmt.toFixed(2) }, () => {
            })
        } else {
            this.setState({ onAccAmt: 0.00 })
        }
    }

    // auto fill received amount
    autoFillReceivedAmount() {
        const { totalAmount, chekedPerformaList } = this.state

        var balanceAmount = parseFloat(totalAmount)
        var sumOfAmount = 0
        var Flag = true
        if (chekedPerformaList.length > 0) {
            this.setState({ award_event_profile_id: chekedPerformaList[0]['award_event_profile_id'] })
        }

        chekedPerformaList.map((data, i) => {
            if (data.outstanding >= totalAmount) {
                data.ReceivedAmount = totalAmount
            } else {
                data.ReceivedAmount = data.outstanding
            }
        })

        // chekedPerformaList.map((data, i) => {
        //     if (i == 0) {
        //         if (parseFloat(totalAmount) >= parseFloat(data.outstanding)) {
        //             data.ReceivedAmount = parseFloat(data.outstanding)
        //             balanceAmount = balanceAmount - parseFloat(data.outstanding)
        //             sumOfAmount += data.ReceivedAmount
        //         } else {
        //             data.ReceivedAmount = balanceAmount
        //             Flag = false
        //         }
        //     } else {
        //         if (balanceAmount >= parseFloat(data.outstanding)) {
        //             data.ReceivedAmount = parseFloat(data.outstanding)
        //             balanceAmount = balanceAmount - parseFloat(data.outstanding)
        //             sumOfAmount += data.ReceivedAmount
        //         } else {
        //             if (Flag) {
        //                 data.ReceivedAmount = parseFloat(totalAmount) - sumOfAmount
        //                 Flag = false
        //             } else {
        //                 data.ReceivedAmount = ''
        //             }
        //         }
        //     }
        // })
        this.setState({ chekedPerformaList: chekedPerformaList })
    }

    // handle tds Amount
    handletdsAmount(e) {
        this.setState({ tdsAmount: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '', tdsAmountErr: "" })
        this.handleTotalAmt()
        const { totalCurrPend } = this.calculateTotals()
        setTimeout(() => {
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            }
        }, 500);
        setTimeout(() => {
            this.autoFillReceivedAmount()
        }, 500);
    }

    handleTotalAmt() {
        const { bankAmount, tdsAmount } = this.state
        var bankAmt = bankAmount != "" ? bankAmount : "0"
        var tdsAmt = tdsAmount != "" ? tdsAmount : "0"
        if (bankAmt != "" && tdsAmt != "") {

            const totalCal = parseFloat(bankAmt) + parseFloat(tdsAmt)
            this.setState({ totalAmount: totalCal != '' ? totalCal.toFixed(2) : '', isTotalAmountAvailable: totalCal > 0 ? true : false }, () => {
            })
        } else {
            this.setState({ totalAmount: "", isTotalAmountAvailable: false })

        }
    }

    addOtherCharges(i) {
        const { otherChargesList } = this.state;
        const checkedBlank = otherChargesList.every(item => item.AccountTypeID != '' && item.Amount != "")
        if (checkedBlank) {
            var obj = {
                AccountTypeID: "",
                Amount: "",
                deleteRowId: i++,
            };
            otherChargesList.push(obj);
            this.setState({
                otherChargesList: otherChargesList,
            });
        } else {
            toastError("please enter charges value")
        }
    }

    deleteOtherCharges(deleteRowId) {
        const { otherChargesList } = this.state;
        var list = otherChargesList.filter(
            (data) => data.deleteRowId != deleteRowId
        );

        this.setState({
            otherChargesList: list,
        });
    }
    SendOutstanding() {
        const ReceiptId = this.props.location.state.receipt_id
        this.setState({ isLoading: true })
        this.props.receipt_outstanding_mail_action(ReceiptId)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess("Outstanding Mail Sent Successfully")
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    addAccountReceiptList() {
        const {
            UserId, voucherId, applicant_id, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, paymentModeId, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaInvoiceRecieptList, otherChargesList, voucherTypeErr, LedgerCreditAmountErr, chekedPerformaList,
            applicantErr,
            bankAccountErr,
            bankAmountErr,
            tdsAmountErr, OrderNo,
            isGenVoucherDisabled, OrderID, ledgerList
        } = this.state;

        const applicantID = this.props.location.state != null && this.props.location.state.applicantID != null ? this.props.location.state.applicantID : ''
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

        const { totalReceivedAmt } = this.calculateTotals()
        const performaArray = [];
        chekedPerformaList.map((data, i) => {
            performaArray.push(
                {
                    'proforma_invoice_id': data.proforma_invoice_id,
                    'recvdAmt': data.ReceivedAmount,
                }
            );
        });

        const otherChargesArray = []
        otherChargesList.map((data, i) => {
            if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
                otherChargesArray.push(
                    {
                        'account_type_id': data.AccountTypeID,
                        'amount': data.Amount
                    }
                )
            }
        })

        const ledgerArray = []
        ledgerList.map((data, i) => {
            ledgerArray.push(
                {
                    'Accounts': data.Account,
                    'Credit': data.Credit,
                    'Debit': data.Debit
                }
            )
        })

        var receiveAccAmount = (parseFloat(onAccAmt != '' ? onAccAmt : 0) + parseFloat(totalReceivedAmt != '' ? totalReceivedAmt : 0))

        this.inputValidate()
        if (voucherId != "" && applicant_id != "" && bankAccountId != "" && bankAmount != "") {
            if (voucherTypeErr == "" && applicantErr == "" && bankAccountErr == "" && bankAmountErr == "") {

                if (isGenVoucherDisabled) {
                    if (receiveAccAmount == totalAmount) {
                        if (paymentModeId != "" && paymentModeId != "Select") {
                            if (LedgerCreditAmountErr == '') {
                                this.setState({ isLoading: true })
                                this.props
                                    .receipt_entry_save_action(
                                        parseInt(voucherId), applicant_id, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, parseInt(paymentModeId), instrumentNo, instrumentDate, bankName, branchName, narration, paymentReceivedDate, parseInt(bankAccountId), currency, performaArray, otherChargesArray,
                                    )
                                    .then((data) => {
                                        if (data.error != 1) {
                                            this.setState({ isLoading: false })
                                            toastSuccess("Receipt Insert Successfully")
                                            setTimeout(() => {
                                                this.handleCancel()
                                            }, 500);
                                        } else {
                                            responseError(data)
                                        }
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                    });
                            } else {
                                toastError("Total Credit amount must match the total Receipt amount")
                            }
                        } else {
                            toastError("Please Select payment Mode")
                        }
                    } else {
                        toastError("Total Amounts Not Matched")
                    }
                }
                else {
                    toastError("Please Generate Voucher")
                }
            } else {
                toastError("Please Fill Mandatory Fields")
            }
        } else {
            toastError("Please Fill Mandatory Fields")
        }

    }
    updateAccountReceiptList() {
        const {
            UserId, voucherId, applicant_id, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, paymentModeId, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaInvoiceRecieptList, otherChargesList, chekedPerformaList, voucherTypeErr, LedgerCreditAmountErr,
            applicantErr,
            bankAccountErr,
            bankAmountErr,
            tdsAmountErr, OrderNo,
            isGenVoucherDisabled, OrderID, ledgerList,
        } = this.state;
        const ReceiptId = this.props.location.state.receipt_id

        const applicantID = this.props.location.state != null && this.props.location.state.applicantID != null ? this.props.location.state.applicantID : ''
        const CenterID = this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : ''

        const { totalReceivedAmt } = this.calculateTotals()
        const performaArray = [];
        chekedPerformaList.map((data, i) => {
            performaArray.push(
                {
                    'proforma_invoice_id': data.proforma_invoice_id,
                    'recvdAmt': data.ReceivedAmount,
                }
            );
        });

        const otherChargesArray = []
        otherChargesList.map((data, i) => {
            if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
                otherChargesArray.push(
                    {
                        'account_type_id': data.AccountTypeID,
                        'amount': data.Amount
                    }
                )
            }
        })

        const ledgerArray = []
        ledgerList.map((data, i) => {
            ledgerArray.push(
                {
                    'Accounts': data.Account,
                    'Credit': data.Credit,
                    'Debit': data.Debit
                }
            )
        })

        var receiveAccAmount = (parseFloat(onAccAmt != '' ? onAccAmt : 0) + parseFloat(totalReceivedAmt != '' ? totalReceivedAmt : 0))

        this.inputValidate()
        if (voucherId != "" && applicant_id != "" && bankAccountId != "" && bankAmount != "") {
            if (voucherTypeErr == "" && applicantErr == "" && bankAccountErr == "" && bankAmountErr == "") {
                if (isGenVoucherDisabled) {
                    if (receiveAccAmount == totalAmount) {
                        if (paymentModeId != "" && paymentModeId != "Select") {
                            if (LedgerCreditAmountErr == '') {
                                this.setState({ isLoading: true });
                                this.props
                                    .receiptUpdate_action(
                                        ReceiptId, parseInt(voucherId), applicant_id, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, receiptNo, receiptDate, parseInt(paymentModeId), instrumentNo, instrumentDate, bankName, branchName, narration, paymentReceivedDate, parseInt(bankAccountId), currency, performaArray, otherChargesArray,
                                    )
                                    .then((data) => {
                                        if (data.error != 1) {
                                            this.setState({ isLoading: false });
                                            toastSuccess("Receipt Update Successfully")
                                            setTimeout(() => {
                                                this.handleCancel()
                                            }, 500);
                                        } else {
                                            responseError(data)
                                        }
                                    })
                                    .catch((e) => {
                                        console.log(e);
                                    });
                            } else {
                                toastError("Total Credit amount must match the total Receipt amount")
                            }
                        } else {
                            toastError("Please Select payment Mode")
                        }
                    } else {
                        toastError("Total Amounts Not Matched")
                    }
                }
                else {
                    toastError("Please Generate Voucher")
                }
            } else {
                toastError("Please Fill Mandatory Fields")
            }
        } else {
            toastError("Please Fill Mandatory Fields")
        }

    }

    previewReceipt() {
        const { receiptNo } = this.state;
        const ReceiptId = this.props.location.state.ReceiptId
        this.setState({ isLoading: true });
        this.props
            .preview_receipt_action(ReceiptId, receiptNo)
            .then((data) => {
                if (data.error != 1) {
                    const url = BASE_URL.split("/api")[0];
                    const structurePath = data.data.filePath.replace('./', '/');
                    const FilePath = `${url}${structurePath}`;
                    this.setState({ isLoading: false, receiptPreviewModal: true, receiptFilePath: FilePath });
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onSendMailReceipt() {
        const { bankAmount, tdsAmount, rptDetailsObj } = this.state;
        const ReceiptId = this.props.location.state.ReceiptId
        this.setState({ isLoading: true });
        this.props
            .getSendMailReceiptDetailsUrl_action(ReceiptId, rptDetailsObj.OrderNo, bankAmount, tdsAmount)
            .then((data) => {
                if (data.error != 1) {
                    // this.props.navigate("/accountReceiptsList");
                    toastSuccess("Receipt Send Successfully")
                    this.setState({ isLoading: false });
                } else {
                    responseError(data)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    otherChargesReceiptAmount(e, index) {
        const { otherChargesList } = this.state
        const list = [...otherChargesList]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['Amount'] = e.target.value.replace(/\D/, '')

            }
        }
        this.setState({
            otherChargesList: list
        })
    }

    otherChargesReceiptAccountTypeId(e, index) {

        const { otherChargesList } = this.state
        const list = [...otherChargesList]
        for (let i = 0; i < list.length; i++) {
            if (i == index) {
                list[i]['AccountTypeID'] = e.target.value
            }
            if (list[i]['AccountTypeID'] == 'Select') {
                list[i]['Amount'] = ''
            }
        }

        this.setState({
            otherChargesList: list
        })

    }

    handleCancel() {
        this.props.navigate('/receiptList')
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    handleContinue() {
        const { totalAmount, performaInvoiceRecieptList } = this.state
        this.setState({ show: false })

        var list = [...performaInvoiceRecieptList];

        for (var i = 0; i < performaInvoiceRecieptList.length; i++) {
            if (performaInvoiceRecieptList[i].Is_Check == 1) {
                if (list.length == 0) {
                    list.push(performaInvoiceRecieptList[i])
                } else {
                    var isAvailable = false;
                    for (var j = 0; j < list.length; j++) {
                        if (list[j].proforma_invoice_id == performaInvoiceRecieptList[i].proforma_invoice_id) {
                            isAvailable = true;
                        }
                    }
                    if (!isAvailable) {
                        list.push(performaInvoiceRecieptList[i])
                    }
                }
            } else {
                for (var k = 0; k < list.length; k++) {
                    if (list[k].proforma_invoice_id == performaInvoiceRecieptList[i].proforma_invoice_id) {
                        list.splice(k, 1)
                    }
                }
            }
        }
        this.setState({ chekedPerformaList: list }, () => {
            this.autoFillReceivedAmount()
        })
        setTimeout(() => {
            this.calculateTotals()
        }, 300);

        setTimeout(() => {
            const { totalCurrPend } = this.calculateTotals()
            if (totalCurrPend != 0) {
                this.handleOnAccAmt()
            } else {
                this.setState({ onAccAmt: 0.00 })
            }
        }, 500);
    }

    preventNegative(e) {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()

        if (e.code === 'Minus') {
            e.preventDefault();
        }
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            const currentVal = parseFloat(e.target.value);
            const increment = e.key === "ArrowUp" ? 1 : -1;
            const newVal = currentVal + increment;
            if (newVal < 0) {
                e.preventDefault()
            }
        }
    }

    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    receivedAmmountReceipt(e, index) {
        const { chekedPerformaList } = this.state
        const newList = [...chekedPerformaList]
        const event = e.target.value.replace(/\D/, '')
        this.setState({ totalAmountErr: '' })

        newList.forEach((data, i) => {
            if (i === index) {
                if (parseFloat(data.outstanding) >= parseFloat(event)) {
                    data.ReceivedAmount = event
                } else {
                    toast.error("Received amount must be less than or equal to pending amount", {
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                    });
                    data.ReceivedAmount = ''
                }
            }
        });
        this.setState({
            chekedPerformaList: newList,
        });
    }

    calculateTotals() {
        try {
            const { chekedPerformaList } = this.state

            let totalTaxableAmt = 0;
            let totalPayableAmt = 0;
            let totalIgst = 0;
            let totalCgst = 0;
            let totalSgst = 0;
            let totalRound_off = 0;
            let totalCurrPend = 0;
            let totalReceivedAmt = 0;
            let totalSecurityDeposit = 0;

            chekedPerformaList.forEach((data) => {
                totalTaxableAmt += Number(data.taxable_amt);
                totalPayableAmt += Number(data.grand_total);
                totalIgst += Number(data.igst);
                totalCgst += Number(data.cgst);
                totalSgst += Number(data.sgst);
                totalRound_off += Number(data.Round_Off);
                totalCurrPend += Number(data.outstanding);
                totalReceivedAmt += Number(data.ReceivedAmount)
            });
            return {
                totalTaxableAmt,
                totalPayableAmt,
                totalIgst,
                totalCgst,
                totalSgst,
                totalRound_off,
                totalCurrPend,
                totalReceivedAmt,
                totalSecurityDeposit,
            };

        } catch (e) {
            console.log('exception : ', e);
        }

    }

    sumOfObject(list, param) {
        const sumOfList = list.reduce((accumulator, value) => {
            if (param == 'Debit') {
                return accumulator + value.Debit;
            } else {
                return accumulator + value.Credit;
            }
        }, 0);

        return sumOfList
    }

    generateVoucher() {
        const { applicant_id, bankAccountId, currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount, performaInvoiceRecieptList, otherChargesList, subledgerList, ledgerList, voucherId, account, ammount, chekedPerformaList, ReceiptId, paidAmount, award_event_profile_id, } = this.state
        const { totalReceivedAmt } = this.calculateTotals()
        var receiveAccAmount = (onAccAmt != '' && onAccAmt != null ? parseFloat(onAccAmt) + parseFloat(totalReceivedAmt) : totalReceivedAmt != '' ? parseFloat(totalReceivedAmt) : 0)
        const performaArray = [];
        chekedPerformaList.map((data, i) => {
            performaArray.push(
                {
                    'proforma_invoice_id': data.proforma_invoice_id,
                    'recvdAmt': data.ReceivedAmount,
                }
            )
        })

        const otherChargesArray = []
        otherChargesList.map((data, i) => {
            if (data.AccountTypeID != '' && data.AccountTypeID != 'Select' && data.Amount != '') {
                otherChargesArray.push(
                    {
                        'account_type_id': data.AccountTypeID,
                        'amount': data.Amount
                    }
                )
            }
        })

        var ReceivedAmount = false
        const performatList = chekedPerformaList.every(item => item.ReceivedAmount != '' && item.ReceivedAmount != 0)
        if (performatList) {
            ReceivedAmount = true
        } else {
            ReceivedAmount = false
        }
        // this.setState({ isLoading: true });
        console.log("parseInt(receiveAccAmount)--->", parseInt(receiveAccAmount))
        console.log("parseInt(totalAmount)--->", parseInt(totalAmount))
        this.inputValidate()
        if (voucherId != '' && voucherId != 'Select' && tdsAmount != '' && applicant_id != '' && bankAccountId != '' && bankAccountId != 'Select' && bankAmount != '') {
            if (performaArray != '') {
                if (ReceivedAmount) {
                    if (parseInt(receiveAccAmount) == parseInt(totalAmount)) {
                        this.props
                            .generateVoucher_action(applicant_id, voucherId, parseInt(bankAccountId), currency, conversionRate, bankAmount, tdsAmount, exchdiif, onAccAmt != '' ? onAccAmt : 0, crAmount != '' ? crAmount : 0, totalAmount, sessionStorage.getItem("award_event_id"), award_event_profile_id, performaArray, otherChargesArray)
                            .then((data) => {
                                if (data.error != 1) {
                                    //adding some of ledger........................
                                    var ledgerList = data.data.ledger
                                    var ledgerDebitSum = 0
                                    var ledgerCreditSum = 0
                                    var mapLedger;
                                    for (var i = 0; i < ledgerList.length; i++) {
                                        ledgerDebitSum = ledgerDebitSum + ledgerList[i].Debit
                                        ledgerCreditSum = ledgerCreditSum + ledgerList[i].Credit
                                        // if (i == (ledgerList.length - 1)) {
                                        //     mapLedger = {
                                        //         Account: "Total",
                                        //         Credit: ledgerDebitSum,
                                        //         Debit: ledgerCreditSum
                                        //     }
                                        // }
                                    }
                                    if (mapLedger != null) {
                                        ledgerList.push(mapLedger)
                                    }
                                    //adding some of sub-ledger........................
                                    var subledgerList = data.data.subledger
                                    var subledgerDebitSum = 0
                                    var subledgerCreditSum = 0
                                    var mapSubLedger;
                                    for (var i = 0; i < subledgerList.length; i++) {
                                        subledgerDebitSum = subledgerDebitSum + subledgerList[i].Debit
                                        subledgerCreditSum = subledgerCreditSum + subledgerList[i].Credit
                                        if (i == (subledgerList.length - 1)) {
                                            mapSubLedger = {
                                                Account: "Total",
                                                Credit: subledgerDebitSum,
                                                Debit: subledgerCreditSum
                                            }
                                        }
                                    }
                                    if (mapSubLedger != null) {
                                        subledgerList.push(mapSubLedger)
                                    }
                                    this.setState({
                                        isLoading: false,
                                        ledgerList: ledgerList,
                                        subLedgerList: subledgerList,
                                        isGenVoucherDisabled: true
                                    })
                                } else {
                                    responseError(data)
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                            });

                    } else {
                        toastError("Total amounts are not matched")
                        this.setState({ totalAmountErr: 'Total amounts are not matched' })
                    }
                } else {
                    toastError("please enter received amount")
                }
            } else {
                toastError("please select proforma list")
            }
        } else {
            toastError("Please enter mandatory fields!")
        }
    }

    clearVoucher() {

        if (this.props.location.state.Is_update) {
            this.setState({ isEditGenerateVoucher: true, isDisplayapplicantList: false })
        } else {
            this.setState({
                isDisplayapplicantList: false,
            })
        }
        this.setState({
            isGenVoucherDisabled: false
        })
        // window.location.reload()

    }

    onLedgerDebit(e, i) {
        const { ledgerList } = this.state
        const event = e.target.value
        ledgerList.map((item, index) => {
            if (i === index) {
                if (event != '') {
                    item.Debit = parseFloat(event)
                } else {
                    item.Debit = ''
                }
            }
        })
        this.setState({ ledgerList: ledgerList })
    }
    onLedgerCredit(e, i) {
        const { ledgerList } = this.state
        const event = e.target.value
        ledgerList.map((item, index) => {
            if (i === index) {
                if (event != '') {
                    item.Credit = parseFloat(event)
                } else {
                    item.Credit = 0
                }
            }
        })
        const value = this.sumObjectValues(ledgerList)
        if (ledgerList[7]['Debit'] != value) {
            this.setState({ LedgerCreditAmountErr: 'Total Credit amount must match the total Receipt amount' })
        } else {
            this.setState({ LedgerCreditAmountErr: '' })
        }
        this.setState({ ledgerList: ledgerList })
    }

    sumObjectValues(arr) {
        let sum = 0;
        arr.forEach(item => {
            for (const key in item) {
                if (key === 'Credit') {
                    sum += item.Credit;
                }
            }
        });
        sum = Math.round(sum * 100) / 100;

        // Format with commas and two decimal places
        // return sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        return sum
    }

    //For Ledger Table Create 
    createLedgerTable() {
        const { ledgerList } = this.state
        var list = [...ledgerList]
        var ledgerColumnArray = []
        var ledgerRowData = []
        // saving all keys of ledger data
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, i) => {
                    ledgerColumnArray.push(key)
                })
            }
        })
        // saving all row data 
        list.map((data) => {
            ledgerRowData.push(data)
        })
        return (
            <div className="col-md-6">
                <p className="mb-0">
                    {ledgerColumnArray.length > 0 && <strong>Ledger</strong>}
                </p>
                <div className="table-responsive mb-1">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead>
                            <tr key={Math.random()} >
                                {
                                    ledgerColumnArray.length > 0 && ledgerColumnArray.map((data, index) => (
                                        <th>{data}</th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ledgerRowData.length > 0 && ledgerRowData.map((data, index) => (
                                    <tr key={index}>
                                        <td>{data.account}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Debit}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Credit}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    //create sub Ledger Table
    createSubLedgerTable() {
        const { subLedgerList } = this.state
        var list = [...subLedgerList]
        var subLedgerColumnArray = []
        var subLedgerRowData = []
        // saving all keys of ledger data
        list.map((data, index) => {
            if (index == 0) {
                Object.keys(data).map((key, i) => {
                    subLedgerColumnArray.push(key)
                })
            }
        })
        // saving All row data
        list.map((data) => {
            subLedgerRowData.push(data)
        })
        return (
            <div className="col-md-6">
                <p className="mb-0">
                    {" "}
                    {subLedgerColumnArray.length > 0 && <strong>Sub Ledger</strong>}
                </p>
                <div className="table-responsive mb-3">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead>
                            <tr key={Math.random()}>
                                {
                                    subLedgerColumnArray.length > 0 && subLedgerColumnArray.map((data) => (
                                        <th>{data}</th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                subLedgerRowData.length > 0 && subLedgerRowData.map((data, index) => (
                                    <tr>
                                        <td>{data.Account}</td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Debit}
                                                disabled={true}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={0.0}
                                                value={data.Credit}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                    </table>
                </div>
            </div>
        )

    }

    onBankAmount(e) {
        const event = e.target.value
        this.setState({ bankAmount: event, bankAmountErr: '', totalAmountErr: '' })
        if (event != '') {
            this.setState({ isDisableProformaInvoice: false })
        } else {
            this.setState({ isDisableProformaInvoice: true })
        }

    }

    // search State
    onApplicantSearch(e) {
        const { applicantNameList, tempApplicantList, countryId } = this.state
        if (e.target.value != '') {
            var searchStateList = applicantNameList.filter(data => {
                return (
                    data
                        .name
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                applicant_name: e.target.value,
                applicantErr: '',
                tempApplicantList: searchStateList,
                isDisplayApplicantList: true
            })
        } else {
            this.setState({
                applicant_name: '',
                applicant_id: '',
                applicantErr: '',
                tempApplicantList: applicantNameList,
                isDisplayApplicantList: false
            })
        }
    }
    // render State
    renderApplicantList() {
        const { tempApplicantList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 100, }}>
                {

                    tempApplicantList.length > 0 &&
                    tempApplicantList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.mainApplicantListData(data)}
                        >{data.name + ' (' + data.application_no + ')'}</li>
                    ))
                    // :
                    // <li class="list-group-item"
                    // >Record not found</li>

                }
            </ul>
        )
    }
    mainApplicantListData(data) {
        this.setState({ applicant_id: data.application_form_id, applicant_name: data.name + ' (' + data.application_no + ')', isDisplayApplicantList: false, applicantErr: '', currency: data.currency }, () => this.getPerformaInvoiceRecieptList(), this.getReceiptNo())
    }

    render() {
        const {
            isLoading, receiptPreviewModal, receiptFilePath, voucherId, voucherList,
            bankAccountId, bankAccountList, paymentModeId, paymentModeList, receiptAccountTypeList,
            applicant_id, applicantNameList, show, performaInvoiceRecieptList, otherChargesList,
            currency, conversionRate, bankAmount, tdsAmount, exchdiif, crAmount, totalAmount,
            receiptNo, receiptDate, paymentReceivedDate, instrumentNo, instrumentDate,
            bankName, branchName, narration, Is_update, voucherTypeErr, applicantErr,
            bankAccountErr, bankAmountErr, tdsAmountErr, pymtModeErr, onAccAmt, isGenVoucherDisabled,
            isEditGenerateVoucher, onPreview, chekedPerformaList, isDisableProformaInvoice,
            totalAmountErr, adminReceipt, paidAmount, isCollapse, createdBy, createdDate,
            deletedBy, deletedDate, modifiedBy, modifiedDate, systemInfo, OrderNo, checkAll,
            isDisplayApplicantList, applicant_name, outstanding } = this.state;
        const { totalTaxableAmt, totalPayableAmt, totalIgst, totalCgst, totalSgst, totalCurrPend, totalReceivedAmt, totalSecurityDeposit, totalRound_off } = this.calculateTotals()
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>

                        <section class='header_margin_top'>
                            <div class="container-fluid">
                                <div className="mb-4">
                                    <div class="page-header">
                                        <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1">Receipts</h2>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Voucher<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    id="state"
                                                    name="Entry Type"
                                                    class="form-control floating-control"
                                                    value={voucherId}
                                                    disabled={isGenVoucherDisabled || onPreview}
                                                    onChange={(e) =>
                                                        this.setState({ voucherId: e.target.value, voucherTypeErr: "" })
                                                    }
                                                >
                                                    <option>Select</option>
                                                    {voucherList.length > 0 &&
                                                        voucherList.map((item) => (
                                                            <option

                                                                key={item.voucher_type_id}
                                                                value={item.voucher_type_id}
                                                            >
                                                                {item.voucher_type_name}
                                                            </option>
                                                        ))}
                                                </select>{<span className='text-danger text-start text-left d-block mt-1'>{voucherTypeErr}</span>}
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label>Applicant Name<span style={{ color: 'red' }}>*</span></label>

                                            <input value={applicant_name} type="text"
                                                disabled={Is_update || isGenVoucherDisabled || onPreview}
                                                onChange={(e) => this.onApplicantSearch(e)}
                                                class="form-control" required
                                                autocomplete="off"
                                                maxLength={30}
                                            />
                                            {isDisplayApplicantList && this.renderApplicantList()}
                                            {<span className='text-danger text-start text-left d-block mt-1'>{applicantErr}</span>}
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Bank Account <span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                    id="state"
                                                    name="Entry Type"
                                                    class="form-control floating-control"
                                                    value={bankAccountId}
                                                    onChange={(e) =>
                                                        this.setState({
                                                            bankAccountId: e.target.value,
                                                            bankAccountErr: ""
                                                        })
                                                    }
                                                >
                                                    <option>Select</option>
                                                    {bankAccountList.length > 0 &&
                                                        bankAccountList.map((item) => (
                                                            <option
                                                                key={item.bank_id}
                                                                value={item.bank_id}
                                                            >
                                                                {item.bank_name}
                                                            </option>
                                                        ))}
                                                </select>{<span className='text-danger text-start text-left d-block mt-1'>{bankAccountErr}</span>}
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Currency</label>
                                                <input
                                                    value={currency}
                                                    type="text"
                                                    class="form-control"

                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Conversion Rate</label>
                                                <input
                                                    value={conversionRate}
                                                    type="text"
                                                    class="form-control"

                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Bank Amount <span style={{ color: 'red' }}>*</span></label>
                                                <input
                                                    disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                    value={bankAmount}
                                                    type="number"
                                                    class="form-control hideIncDec"
                                                    maxLength={'16'}
                                                    onChange={(e) => this.onBankAmount(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onBlur={(e) => this.handleBankAmount(e)}
                                                />{<span className='text-danger text-start text-left d-block mt-1'>{bankAmountErr}</span>}
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>TDS Amount
                                                    <span style={{ color: 'red' }}>*</span>
                                                </label>
                                                <input
                                                    disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                    value={tdsAmount}
                                                    maxLength={'16'}
                                                    type="number"
                                                    class="form-control hideIncDec"
                                                    onChange={(e) => this.setState({ tdsAmount: e.target.value, tdsAmountErr: "" })}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.handletdsAmount(e)}
                                                />{<span className='text-danger text-start text-left d-block mt-1'>{tdsAmountErr}</span>}
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Exch Diff</label>
                                                <input
                                                    disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                    value={exchdiif}
                                                    type="number"
                                                    class="form-control hideIncDec"
                                                    maxLength={'16'}
                                                    onChange={(e) => e.target.value >= 0 && this.setState({ exchdiif: e.target.value.replace(/\D/, '') })}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.setState({ exchdiif: e.target.value != '' ? parseFloat(e.target.value).toFixed(2) : '' })}
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>On Acc Amt</label>
                                                <input
                                                    type="number"
                                                    class="form-control hideIncDec"
                                                    value={onAccAmt}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Cr Amount</label>
                                                <input
                                                    type="number"
                                                    class="form-control hideIncDec"
                                                    value={crAmount}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                    onBlur={(e) => this.setState({ crAmount: parseFloat(e.target.value).toFixed(2) })}
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="form-group mb-3">
                                                <label>Total Amount</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    value={totalAmount}
                                                    maxLength={'16'}
                                                    disabled={true}
                                                    onInput={(e) => this.maxLengthCheck(e, 16)}
                                                    onKeyDown={(e) => this.preventNegative(e)}
                                                    onPaste={(e) => this.handlePaste(e)}
                                                />
                                                {<span className='text-danger text-start text-left d-block mt-1'>{totalAmountErr}</span>}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className=" mb-4">
                                    {/* <div class="col-md-12 mb-3">
                                        <div class="row mr-0">
                                            <div class="col-md-6 padding_0">
                                                <h6>&nbsp;</h6>
                                            </div>
                                            <div class="col-md-6 padding_0">
                                                <div class="text-right">
                                                    <button
                                                        onClick={() => this.modalShow()}
                                                        class="btn btn-outline-primary"
                                                        disabled={isGenVoucherDisabled && !isEditGenerateVoucher || isDisableProformaInvoice || Is_update}
                                                    >
                                                        Select Proforma Invoice
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div class="custom_table">
                                        <div class="hack1">
                                            <div class="hack2">
                                                <table class="table table-bordered" id="dashboard-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Proforma Invoice No</th>
                                                            <th>Proforma Date</th>
                                                            <th>Taxable Amount</th>
                                                            <th>CGST</th>
                                                            <th>SGST</th>
                                                            <th>IGST</th>
                                                            <th>Round off</th>
                                                            <th>Total Payable</th>
                                                            <th>Pending Amount</th>
                                                            <th style={{ width: '10%' }}>Received Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="myTable">
                                                        {chekedPerformaList != "" &&
                                                            chekedPerformaList != null ? (
                                                            chekedPerformaList.map((data, i) => (
                                                                <>
                                                                    <tr>
                                                                        <td>{data.application_no}</td>
                                                                        <td>{data.proforma_invoice_date != null ? moment(data.proforma_invoice_date).format('DD-MM-YYYY') : <></>}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.taxable_amt != null ? data.taxable_amt.toLocaleString("en-IN") : '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.cgst != 0 && data.cgst != '' ? data.cgst.toLocaleString("en-IN") : '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.sgst != 0 && data.sgst != '' ? data.sgst.toLocaleString("en-IN") : '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.igst != 0 && data.igst != '' ? data.igst.toLocaleString("en-IN") : '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.Round_Off != null && data.Round_Off != '' ? data.Round_Off.toLocaleString("en-IN") : '-'}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.grand_total != '' && data.grand_total != null ? data.grand_total.toLocaleString("en-IN") : 0}</td>
                                                                        <td style={{ textAlign: 'right' }}>{data.outstanding != '' && data.outstanding != null ? data.outstanding.toLocaleString("en-IN") : 0}</td>
                                                                        {/* <td style={{ textAlign: 'right' }}>{paidAmount != '' && paidAmount != null ? paidAmount.toLocaleString("en-IN") : 0}</td> */}
                                                                        <td>
                                                                            <input
                                                                                style={{ textAlign: 'right' }}
                                                                                type="text"
                                                                                class="form-control"
                                                                                disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                                                value={data.ReceivedAmount}
                                                                                onChange={(e) => this.receivedAmmountReceipt(e, i)}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                            )
                                                        ) : (
                                                            <></>
                                                        )}
                                                        {
                                                            <tr>
                                                                <td>Total</td>
                                                                <td style={{ textAlign: 'left' }}>-</td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalTaxableAmt != '' ? totalTaxableAmt.toLocaleString("en-IN") : ''}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalCgst != 0 && totalCgst != '' ? totalCgst.toLocaleString("en-IN") : '-'}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalSgst != 0 && totalSgst != '' ? totalSgst.toLocaleString("en-IN") : '-'}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalIgst != 0 && totalIgst != '' ? totalIgst.toLocaleString("en-IN") : '-'}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalRound_off != 0 && totalRound_off != '' ? totalRound_off.toLocaleString("en-IN") : '-'}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalPayableAmt != '' ? totalPayableAmt.toLocaleString("en-IN") : ''}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalCurrPend != '' ? totalCurrPend.toLocaleString("en-IN") : ''}
                                                                </td>
                                                                <td style={{ textAlign: 'right' }}>
                                                                    {totalReceivedAmt != '' ? totalReceivedAmt.toLocaleString("en-IN") : ''}
                                                                </td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div>
                                                <div class="">
                                                    <div class="row mr_0 m-0">
                                                        <div class="col-md-12 padding_0">
                                                            <p class="mb-2 mt-3 text-dark">Other Charges</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="custom_table">
                                                    <div class="hack1">
                                                        <div class="hack2">
                                                            <table class="table table-bordered" id="dashboard-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left" style={{ width: '4%' }}></th>
                                                                        <th>Account</th>
                                                                        <th>Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody id="myTable">
                                                                    {
                                                                        otherChargesList.map((data, i) => (
                                                                            <tr>
                                                                                <td class="text-center">
                                                                                    {otherChargesList.length == i + 1 ? (
                                                                                        <>
                                                                                            {
                                                                                                <a
                                                                                                    title="Add"
                                                                                                    class="btn btn-sm"
                                                                                                    onClick={() =>
                                                                                                        this.addOtherCharges(
                                                                                                            data.deleteRowId + 1
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <i class="fa fa-plus-square-o pt-2 text-primary fa-lg"></i>
                                                                                                </a>
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                    {otherChargesList.length != 1 ? (
                                                                                        <>
                                                                                            {
                                                                                                <a
                                                                                                    title="Delete"
                                                                                                    class="btn btn-sm delete_record"
                                                                                                    onClick={() =>
                                                                                                        this.deleteOtherCharges(
                                                                                                            data.deleteRowId
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    <i class="fa fa-trash action_btn_table"></i>
                                                                                                </a>
                                                                                            }
                                                                                        </>
                                                                                    ) : (
                                                                                        <></>
                                                                                    )}
                                                                                </td>
                                                                                <td>
                                                                                    <select
                                                                                        id="state"
                                                                                        name="Entry Type"
                                                                                        class="form-control floating-control"
                                                                                        value={data.AccountTypeID}
                                                                                        onChange={(e) => this.otherChargesReceiptAccountTypeId(e, i)
                                                                                        }
                                                                                        disabled={isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                                                    >
                                                                                        <option>Select</option>
                                                                                        {receiptAccountTypeList.length > 0 &&
                                                                                            receiptAccountTypeList.map(
                                                                                                (item) => (
                                                                                                    <option
                                                                                                        key={
                                                                                                            item.receipt_account_type_id
                                                                                                        }
                                                                                                        value={
                                                                                                            item.receipt_account_type_id
                                                                                                        }
                                                                                                    >
                                                                                                        {item.account_type}
                                                                                                    </option>
                                                                                                )
                                                                                            )}
                                                                                    </select>
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        class="form-control hideIncDec"
                                                                                        disabled={data.AccountTypeID == '' || data.AccountTypeID == 'Select' || isGenVoucherDisabled && !isEditGenerateVoucher || onPreview}
                                                                                        value={data.Amount}
                                                                                        onChange={(e) => this.otherChargesReceiptAmount(e, i)}
                                                                                    />
                                                                                </td>

                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-md-12 text-right">
                                            {
                                                isGenVoucherDisabled && !isEditGenerateVoucher ?
                                                    <button class="btn btn-outline-danger"
                                                        onClick={() => this.clearVoucher()}
                                                    >Clear Voucher</button>
                                                    :
                                                    <button class="btn btn-outline-primary"
                                                        onClick={() => this.generateVoucher()}
                                                    >Generate Voucher</button>
                                            }
                                        </div>
                                    </div>

                                    <div class="row">
                                        {
                                            isGenVoucherDisabled && this.createLedgerTable()
                                        }
                                        {
                                            isGenVoucherDisabled && this.createSubLedgerTable()
                                        }
                                    </div>
                                    <div>
                                        <div class="outside_input_field ">
                                            <div class="row mt-2">
                                                <div class="col-md-12 mb-3">
                                                    <div class="form-group">
                                                        <div class="position-relative">
                                                            <textarea
                                                                value={narration}
                                                                onChange={(e) => this.setState({ narration: e.target.value })}
                                                                class="form-control outside"
                                                                rows="3"
                                                                placeholder="Narration"
                                                                disabled={onPreview}
                                                            ></textarea>
                                                            {/* <span class="floating-label-outside">
                                                            Narration
                                                        </span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 mb-3">
                                                <label>Receipt no</label>
                                                <input type="text"
                                                    value={receiptNo}
                                                    class="form-control" disabled />
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Receipt Date</label>
                                                <input type="text"
                                                    value={receiptDate != '' ? moment(receiptDate).format('DD-MM-YYYY') : ''}
                                                    onChange={(e) => this.setState({ receiptDate: e.target.value })}
                                                    class="form-control" disabled />
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Payment Received Date</label>
                                                <div style={{ zIndex: '99' }} className="form-group d-flex" >
                                                    <DatePicker className="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date}
                                                        selected={paymentReceivedDate}
                                                        onChange={(date) => {
                                                            this.setState({ paymentReceivedDate: date })
                                                        }}
                                                        disabled={onPreview}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="DD/MM/YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Payment Mode<span style={{ color: 'red' }}>*</span></label>
                                                <select
                                                    id="state"
                                                    name="Entry Type"
                                                    class="form-control floating-control"
                                                    value={paymentModeId}
                                                    disabled={onPreview}
                                                    onChange={(e) =>
                                                        this.setState({ paymentModeId: e.target.value, pymtModeErr: '' })
                                                    }
                                                >
                                                    <option>Select</option>
                                                    {paymentModeList.length > 0 &&
                                                        paymentModeList.map((item) => (
                                                            <option
                                                                key={item.payment_mode_id}
                                                                value={item.payment_mode_id}
                                                            >
                                                                {item.payment_mode}
                                                            </option>
                                                        ))}
                                                </select>{<span className='text-danger text-start text-left d-block mt-1'>{pymtModeErr}</span>}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3 mb-3">
                                                <label>Instrument no</label>
                                                <input type="text"
                                                    value={instrumentNo}
                                                    disabled={onPreview}
                                                    onChange={(e) => this.setState({ instrumentNo: e.target.value })}
                                                    class="form-control" />
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Instrument Date</label>
                                                <div style={{ zIndex: '99' }} className="form-group d-flex" >
                                                    <DatePicker className="form-control"
                                                        dateFormat="dd-MM-yyyy"
                                                        selected={instrumentDate}
                                                        onChange={(date) => {
                                                            this.setState({ instrumentDate: date })
                                                        }}
                                                        disabled={onPreview}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="DD/MM/YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Bank Name</label>
                                                <input type="text"
                                                    onChange={(e) => this.setState({ bankName: e.target.value })}
                                                    value={bankName}
                                                    disabled={onPreview}
                                                    class="form-control" />
                                            </div>
                                            <div class="col-md-3 mb-3">
                                                <label>Branch Name</label>
                                                <input type="text"
                                                    onChange={(e) => this.setState({ branchName: e.target.value })}
                                                    value={branchName}
                                                    disabled={onPreview}
                                                    class="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.Is_update ? (
                                        <div class="search_accordion search_card">
                                            <div class="panel-group" id="accordion">
                                                <div class="panel panel-default">
                                                    <div
                                                        className="panel-heading accordion-toggle collapsed"
                                                        data-toggle="collapse"
                                                        data-parent="#accordion"
                                                        data-target="#collapseOne"
                                                        aria-expanded={isCollapse}
                                                        onClick={() =>
                                                            this.setState({
                                                                isCollapse: !isCollapse,
                                                            })
                                                        }
                                                    >
                                                        <h4 class="panel-title">System Info</h4>
                                                    </div>
                                                    <div
                                                        id="collapseOne"
                                                        className={`panel-collapse collapse ${isCollapse ? "show" : ""
                                                            }`}
                                                    >
                                                        <div class="panel-body">
                                                            <div class="form-group">
                                                                <div class="row">
                                                                    <div class="col-md-4">
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Created By
                                                                            </label>
                                                                            <p class="Sys_info_style">{systemInfo[0]['Created_by_user']}</p>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Created Date
                                                                            </label>
                                                                            <p class="Sys_info_style">
                                                                                {systemInfo[0]['Created_date'] != null ? moment(systemInfo[0]['Created_date']).format("DD/MM/YYYY") : ''}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-4">
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Modified By
                                                                            </label>
                                                                            <p class="Sys_info_style">{systemInfo[0]['modified_by_user']}</p>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Modified Date
                                                                            </label>
                                                                            <p class="Sys_info_style">
                                                                                {systemInfo[0]['modified_date'] != null ? moment(systemInfo[0]['modified_date']).format("DD/MM/YYYY") : ''}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-md-4">
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Deleted By
                                                                            </label>
                                                                            <p class="Sys_info_style">{systemInfo[0]['deleted_by_user']}</p>
                                                                        </div>
                                                                        <div class="form-group">
                                                                            <label class="sys_info_label" for="email">
                                                                                Deleted Date
                                                                            </label>
                                                                            <p class="Sys_info_style">
                                                                                {systemInfo[0]['deleted_date'] != null ? moment(systemInfo[0]['deleted_date']).format("DD/MM/YYYY") : ''}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}

                                </div>
                                <div className=" mb-4">
                                    <div class="row">
                                        <div class="col-md-12 text-left">
                                            {
                                                Is_update ?
                                                    <>
                                                        {/* <a
                                                            // onClick={() => this.previewReceipt()}
                                                            class="btn btn-success m-1"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Send Receipt
                                                        </a> */}
                                                        <button class="btn btn-outline-success mr-2" onClick={() => this.updateAccountReceiptList()}>Update</button>
                                                    </>
                                                    :

                                                    <button class="btn btn-outline-primary mr-2" onClick={() => this.addAccountReceiptList()}>Save</button>
                                            }
                                            {((sessionStorage.getItem('role_id') == 1 || sessionStorage.getItem('role_id') == 3) && Is_update && outstanding > 0) && <>
                                                <button class="btn btn-outline-warning mr-2" onClick={() => this.SendOutstanding()}>Send Outstanding</button>

                                            </>}
                                            <button class="btn btn-outline-secondary" onClick={() => this.handleCancel()}>Cancel</button>
                                        </div>
                                    </div >
                                </div >
                            </div >
                        </section >
                    </main >
                </>
                <Footer />
                <ToastContainer />

                <Modal show={show} size="xl">
                    <Modal.Header>
                        <Modal.Title className="text-dark">Select Proforma Invoice</Modal.Title>
                        <span className="mr-2"
                            onClick={this.modalClose}
                            style={{ cursor: "pointer", fontWeight: "800" }}
                        >
                            X
                        </span>
                    </Modal.Header>

                    <Modal.Body>
                        <table
                            class="table table-bordered"
                            id="dashboard-table"
                        >
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}>
                                        {/* <div class="bg">
                                            <div class="chiller_cb" style={{ margin: "auto" }}>
                                                <input
                                                    id="ServiceCheck1"
                                                    type="checkbox"
                                                    checked={checkAll}
                                                    onClick={(e) => this.tableHeadCheckbox(e)}
                                                />
                                                <label for="ServiceCheck1" style={{ color: "black" }}>
                                                    &nbsp;
                                                </label>
                                                <span></span>
                                            </div>
                                        </div> */}
                                    </th>
                                    <th style={{ width: '10%' }}>Proforma No</th>
                                    <th style={{ width: '10%' }}>Application No</th>
                                    <th style={{ width: '10%' }}>Proforma Date</th>
                                    <th style={{ width: '10%', textAlign: 'right' }}>Total Payable</th>
                                    <th style={{ width: '10%', textAlign: 'right' }}>Pending Amount</th>
                                </tr>
                            </thead>
                            <tbody id="myTable">
                                {performaInvoiceRecieptList != "" &&
                                    performaInvoiceRecieptList != null ? (
                                    performaInvoiceRecieptList.map((data, i) => (
                                        <tr>
                                            <td>
                                                <div class="bg">
                                                    <div class="" style={{ margin: "auto" }}>

                                                        <label className="d-flex"
                                                            for={`checkbox${i}`}
                                                            style={{ color: "#979797" }}
                                                        >
                                                            <input className="mr-2"
                                                                type="checkbox"
                                                                id={`checkbox${i}`}
                                                                checked={data.Is_Check}
                                                                onClick={(e) =>
                                                                    this.tableBodyCheckbox(i, data.OrderID, e)
                                                                }
                                                            />
                                                            &nbsp;
                                                        </label>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td >{data.proforma_invoice_no}</td>
                                            <td >{data.application_no}</td>
                                            <td style={{ textAlign: 'center' }}>{data.proforma_invoice_date != null ? moment(data.proforma_invoice_date).format('DD-MM-YYYY') : <></>}</td>
                                            <td style={{ textAlign: 'right' }}>{data.grand_total != '' && data.grand_total != null ? data.grand_total.toLocaleString("en-IN") : 0}</td>
                                            <td style={{ textAlign: 'right' }}>{data.outstanding != '' && data.outstanding != null ? data.outstanding.toLocaleString("en-IN") : 0}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8} className="text-center">
                                            Record not found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <button
                            type="submit"
                            onClick={() => this.handleContinue()}
                            class="btn btn-outline-primary mr-2"
                        >
                            Continue
                        </button>
                    </Modal.Body>
                </Modal>
                <Modal
                    show={receiptPreviewModal}
                    // onHide={this.piModalClose}
                    size="lg"
                >
                    <Modal.Header>
                        <Modal.Title>
                            Receipt for Order: {OrderNo}
                        </Modal.Title>

                    </Modal.Header>

                    <Modal.Body>
                        <div class="form-group">
                            {receiptFilePath && (
                                <iframe
                                    title="Receipt"
                                    src={receiptFilePath}
                                    style={{
                                        width: "100%",
                                        height: "600px",
                                        border: "none",
                                    }}
                                />
                            )}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => this.setState({ receiptPreviewModal: false })}
                        >
                            close
                        </Button>
                        <Button
                            variant="success"
                        // onClick={() => this.onSendMailReceipt()}
                        >
                            <i className="fa fa-download" /> Send Receipt
                        </Button>

                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        fill_action, proformaInvoice_action, receiptNo_action, generateVoucher_action,
        receipt_entry_save_action, receiptDetails_action, receiptUpdate_action, receipt_outstanding_mail_action
    })(ReceiptManage)
);
